'use client'

import React from "react";

type ListItem = string | {
    text: string;
    subList: string[];
};

type Term = {
    title: string;
    content: string;
    list: ListItem[];
};

const terms: Term[] = [
    {  
        title: "1. Introduction",
        content: "This Privacy Policy explains how Keeplify (“we”, “our”, or “us”) collects, uses, and protects your personal information when you use our application and related services (the “Service”). By using the Service, you agree to the collection and use of information in accordance with this policy.",
        list: [
           
        ]
    },
    {
        title: "2. Information We Collect",
        content: "We may collect the following types of information:",
        list: [
            'Personal Information: such as email address or user identifier, if provided voluntarily.',
            'Usage Data: including app usage logs, device information, and interaction data.',
            'Technical Data: such as IP address, operating system, and app version.',
        ]
    },
    {
        title: "3. How We Use Your Information",
        content: "We use the collected information to:",
        list: [
            'Provide and maintain the Service',
            'Improve app functionality and user experience',
            'Respond to user inquiries and support requests',
            'Comply with legal obligations',
        ]
    },
    {
        title: "4. Data Storage and Security",
        content: "We take reasonable measures to protect your personal information. However, no method of transmission or storage is completely secure.",
        list: [

        ]
    },
    {
        title: "5. Data Retention",
        content: "We retain personal data only for as long as necessary to fulfill the purposes described in this policy, unless a longer retention period is required by law.",
        list: [
           
        ]
    },
    {
        title: "6. Third-Party Services",
        content: "The Service may use third-party services for analytics or infrastructure. These services may collect information in accordance with their own privacy policies.",
        list: [
            
        ]
    },
    {
        title: "7. Children’s Privacy",
        content: "The Service is not intended for children under the age of 13, and we do not knowingly collect personal information from children.",
        list: [
           
        ]
    },
    {
        title: "8. Changes to This Policy",
        content: "We may update this Privacy Policy from time to time. Changes will be effective when posted within the Service or on our website.",
        list: [
        ]
    },
    {
        title: "9. Contact Us",
        content: "If you have any questions about this Privacy Policy, please contact us at:",
        list: [
            'dlog@dlog9.com',
        ]
    }
];

export default function Information() {
    return (
        <main className="page">
            <div className="container2">               
                {terms.map((term, index) => (
                    <section key={index} className="article">
                        <h2>{term.title}</h2>
                        <p>{term.content}</p>
                        {term.list.length > 0 && (
                            <ol>
                                {term.list.map((item, i) => (
                                    <li key={i}>
                                        {typeof item === 'string' ? item : item.text}
                                        {typeof item === 'object' && item.subList.length > 0 && (
                                            <ul>
                                                {item.subList.map((sub, j) => (
                                                    <li key={j}>{sub}</li>
                                                ))}
                                            </ul>
                                        )}
                                    </li>
                                ))}
                            </ol>
                        )}
                    </section>
                ))}
            </div>
        </main>
    );
}